module.exports = __webpack_public_path__ + "static/media/wi-owm-800.8c69812f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/weather-svg/wi-owm-800.svg
// module id = 838
// module chunks = 0